var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.entry
    ? _c(
        "v-card",
        {
          staticClass: "hit-card",
          style: { "--active-color": _vm.entry.color },
          attrs: {
            elevation: "2",
            outlined: "",
            "max-width": _vm.$vuetify.breakpoint.width < 960 ? 320 : 900,
          },
        },
        [
          _c(
            "div",
            { staticClass: "thumbnail-column" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    bottom: "",
                    "nudge-top": "18px",
                    color: _vm.entry.color,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-card-title",
                              _vm._g(
                                {
                                  staticClass: "card-title",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.$emit("jump")
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "card-title-content",
                                    staticStyle: {
                                      "font-weight": "700",
                                      "text-transform": "uppercase",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.db))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "hit-arrow" }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3672955785
                  ),
                },
                [
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Jump to " + _vm._s(_vm.db.toUpperCase())),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "thumbnail-container",
                  staticStyle: { margin: "16px" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("activate")
                    },
                  },
                },
                [
                  _vm.isActive
                    ? _c(
                        "div",
                        {
                          ref: "viewerSlot",
                          staticClass: "viewer-slot",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            dblclick: function ($event) {
                              return _vm.$emit("activate")
                            },
                          },
                        },
                        [
                          _c("StructureViewerToolbar", {
                            attrs: {
                              isFullscreen: false,
                              isSpinning: _vm.isSpinning,
                              disablePDBButton: true,
                              disableImageButton: true,
                              disableQueryButton: true,
                              disableTargetButton: true,
                              disableArrowButton: true,
                              disableResetButton: false,
                              disableSpinButton: false,
                              disableFullscreenButton: true,
                            },
                            on: {
                              resetView: function ($event) {
                                return _vm.$emit("resetView")
                              },
                              toggleSpin: function ($event) {
                                return _vm.$emit("toggleSpin")
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.thumbnailUrl
                    ? _c("img", {
                        staticClass: "thumbnail-img",
                        attrs: { src: _vm.thumbnailUrl, alt: "" },
                      })
                    : _c("v-skeleton-loader", {
                        attrs: { height: "240", type: "image" },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.mdAndUp
            ? _c("v-divider", {
                staticClass: "hit-card-divider",
                attrs: { vertical: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-content-container" },
            [
              _c(
                "v-card-text",
                [
                  _vm.entry.qTM
                    ? _c(
                        "div",
                        {
                          staticClass: "card-content-entry",
                          attrs: {
                            "data-label":
                              _vm.searchType === "interfacesearch"
                                ? "Query Interface TM-score"
                                : "Query TM-score",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.entry.qTM))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.entry.tTM
                    ? _c(
                        "div",
                        {
                          staticClass: "card-content-entry",
                          attrs: {
                            "data-label":
                              _vm.searchType === "interfacesearch"
                                ? "Target Interface TM-score"
                                : "Target TM-score",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.entry.tTM))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-content-entry",
                      attrs: {
                        "data-label":
                          _vm.mode == 1 ? "Chain Pairing" : "Target",
                      },
                    },
                    [
                      _vm.mode == 1 && _vm.entry.topHit.length > 1
                        ? _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                left: "",
                                "nudge-bottom": 4,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs, value }) {
                                      return [
                                        _c(
                                          "button",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "pairing-picker",
                                                class: {
                                                  "pairing-picker--open": value,
                                                },
                                                attrs: {
                                                  type: "button",
                                                  title:
                                                    _vm.selectedObject.title,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                },
                                              },
                                              "button",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.selectedObject.title)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-icon",
                                              { attrs: { size: "18" } },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$MDI.ChevronDown)
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3623431141
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                _vm._l(_vm.entry.topHit, function (pair) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: pair.title,
                                      attrs: {
                                        "input-value":
                                          pair === _vm.selectedObject,
                                        color: _vm.entry.color,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectedObject = pair
                                        },
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(pair.title)),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.mode == 1
                                    ? _vm.selectedObject.title
                                    : _vm.mode == 2
                                    ? _vm.selectedObject.targetname
                                    : _vm.selectedObject.target
                                ) +
                                "\n                "
                            ),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.entry.hasDescription
                    ? _c(
                        "div",
                        {
                          staticClass: "card-content-entry",
                          attrs: { "data-label": "Description" },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.selectedObject.description)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.entry.hasTaxonomy
                    ? _c(
                        "div",
                        {
                          staticClass: "card-content-entry",
                          attrs: { "data-label": "Taxonomy" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?mode=Info&id=" +
                                  _vm.selectedObject.taxId,
                                target: "_blank",
                                rel: "noopener",
                                title: _vm.selectedObject.taxName,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.selectedObject.taxName))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode == 2
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "IDF-score" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.idfscore)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "RMSD" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.rmsd)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "Node count" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.nodecount)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "Matched residues" },
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: {
                                  title: _vm.selectedObject.targetresidues,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.selectedObject.targetresidues)
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "Probability" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.prob)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "Sequence Identity" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.seqId)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": _vm.columnName },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.eval)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry",
                            attrs: { "data-label": "Score" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedObject.score)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-content-entry graphical",
                            attrs: { "data-label": "Position" },
                          },
                          [
                            _c("Ruler", {
                              attrs: {
                                length: _vm.selectedObject.qLen,
                                start: _vm.selectedObject.qStartPos,
                                end: _vm.selectedObject.qEndPos,
                                color: _vm.selectedObject.color,
                                label: true,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }